import { useContext, useState, useEffect } from "react";
import cn from "classnames";

import "./BirthdayForm.scss";
import ButtonSubmit from "../ButtonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";

import { errorEventsBirthday } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";


import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";

function BirthdayForm({ nextStep }) {

  const { data, setData } = useContext(ContextProfileUser);
  const [errorDate, setErrorDate] = useState({
    month: false,
    day: false,
    year: false,
    message: null,
  });

  const birthday = {
    day: data.day || "",
    month: data.month || "",
    year: data.year || "",
  };

  useEffect(() => {
    const allFilled =
      data?.month && data?.day && data?.year;

    if (allFilled) {
      setErrorDate({
        month: false,
        day: false,
        year: false,
        message: null,
      });
    }
  }, [data]);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const hasMonth = Boolean(data.month);
    const hasDay = Boolean(data.day);
    const hasYear = Boolean(data.year);

    const { day, month, year } = birthday;

    if (!hasDay && !hasMonth && !hasYear) {
      simplyClick("err_lnd_age_nodate");
      setErrorDate({
        month: true,
        day: true,
        year: true,
        message: "Please enter your date of birth",
      });
      return;
    }

    const dateKey = [
      hasMonth ? "M" : "",
      hasDay ? "D" : "",
      hasYear ? "Y" : "",
    ].join("");

    if (errorEventsBirthday[dateKey]) {
      simplyClick(errorEventsBirthday[dateKey]);
      setErrorDate({
        month: !hasMonth,
        day: !hasDay,
        year: !hasYear,
        message: "Please enter your date of birth",
      });
      return;
    }

    const { error, status, errors } = validateAge(
      data.month,
      data.day,
      data.year,
    );

    if (!status) {
      setErrorDate({
        month: errors.month || errors.invalidDate,
        day: errors.day || errors.invalidDate,
        year: errors.year || errors.invalidDate,
        message: error,
      });
      return;
    }

    const formattedDate = getBirthdayInFormat(
      data.year,
      data.month,
      data.day,
    );

    setData({
      ...data,
      birthday: getBirthdayInFormat(year, month, day),
      day,
      month,
      year,
    });

    simplyClick("cl_lnd_date_birth_next", { text: formattedDate });
    nextStep();
  };

  const handleDateChange = (field) => ({ target: { value } }) => {
    setData((prev) => ({ ...prev, [field]: value }));
    setErrorDate((prev) => ({ ...prev, [field]: false }));
    simplyClick(`cl_lnd_date_birth_${field}_choose`, { text: value });
  };

  return (
    <div className="promo__wrapper-birthday">
      <div className="user__form-top">
        <h3>My date of birth</h3>
      </div>
      <form className="form__date" onSubmit={handlerSubmit}>
        <div className="dates_error">
          <div className="date__wrapper">
            <div className="date__wrapper-select aqa-test-month">
              <select
                className={cn({
                  active: data.month,
                  error: errorDate.month,
                })}
                onChange={handleDateChange("month")}
                value={data.month || "default"}
              >
                <option value="default" disabled hidden>
                  Month
                </option>
                {getMonths().map((item, index) => (
                  <option key={index} value={index + 1}>
                    {item || ""}
                  </option>
                ))}
              </select>
            </div>
            <div className="date__wrapper-select aqa-test-day">
              <select
                className={cn({
                  active: data.day,
                  error: errorDate.day,
                })}
                onChange={handleDateChange("day")}
                value={data.day || "default"}
              >
                <option value="default" disabled hidden>
                  Day
                </option>
                {getDate().map((item, index) => (
                  <option key={index} value={item}>
                    {item || ""}
                  </option>
                ))}
              </select>
            </div>
            <div className="date__wrapper-select aqa-test-year">
              <select
                className={cn({
                  active: data.year,
                  error: errorDate.year,
                })}
                onChange={handleDateChange("year")}
                value={data.year || "default"}
              >
                <option value="default" disabled hidden>
                  Year
                </option>
                {getYears().map((item, index) => (
                  <option key={index} value={item}>
                    {item || ""}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {errorDate.message && (
            <p className="errorDate">{errorDate.message}</p>
          )}
        </div>
        <div className={"birthday_confirm"}>
          By proceeding, you confirm you are at least 18 years old and fully legally capable of using our website
        </div>

        <ButtonSubmit
          className={"button__global button__birthday"}
          text={"NEXT"}
        />
        <ProgressDots total={6} activeCount={3} />
      </form>
    </div>
  );
}

export default BirthdayForm;
